<ng-container *ngIf="state$ | async as state">
  <div [data-preview-id]="state.id"
       class="modal modal-clinical in"
  >
    <div class="modal-dialog">
      <div class="modal-content"
           data-cy="disclaimer-container"
      >
        <div class="note">
          <div [data-preview-id]="'#' + state.text?.name"
               [id]="'text-' + state.id"
               [innerHTML]="state.text?.value | safeHtml"
               class="disclaimer-text"
               data-cy="disclaimer-modal-text"
               mbCmsInnerHTML
          ></div>
          <button [data-preview-id]="'#' + state.buttonText?.name"
                  [id]="'buttonText-' + state.id"
                  [innerHTML]="state.buttonText?.value | safeHtml"
                  (click)="close()"
                  class="btn btn-sm btn-primary disclaimer-close-button"
                  data-cy="disclaimer-modal-close-button"
                  data-dismiss="modal"
                  aria-label="Close"
                  type="button"
                  mbCmsInnerHTML
          ></button>
        </div>
      </div>
    </div>
  </div>
</ng-container>

